<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="bg-white p-5 shadow m-2">
      <form id="basic" @submit.prevent="updateCourse">
        <div class="grid grid-cols-2 items-center mt-5">
          <div>
            <div class="text-3xl font-bold inline-block"> Edit {{ Type !== typeConsants.SEGMENT ? "Product" : "List"}}</div>
            <br />
            <div class="text-xl inline-block text-gray-600">
              Enter {{ Type !== typeConsants.SEGMENT ? "product" : "List"}} details
            </div>
          </div>
          <div class="text-right">
            <input
              v-if="Type !== typeConsants.SEGMENT"
              type="checkbox"
              v-model="publish"
              class="toggle align-middle"
            />
            <div v-if="Type !== typeConsants.SEGMENT" class="text-lg font-bold inline-block ml-3">Publish</div>
            <button
              :disabled="(Type!==typeConsants.SEGMENT ||  title.trim() === '') &&
                (description.trim() === '' ||
                title.trim() === '' ||
                (scheduled && !Frequency) ||
                (Deliver === 'TWEET'
                  ? !scheduled || !Frequency
                  : !linear && !Frequency))
              "
              type="submit"
              class="btn btn-primary text-lg ml-3"
            >
              Save
            </button>
          </div>
        </div>

        <div class="mt-4">
          <input
            type="text"
            placeholder="Title (required)"
            class="input input-bordered w-full mb-2"
            required
            name="title"
            v-model="title"
            @input="onEdit"
          />
          <textarea
            class="textarea h-64 textarea-bordered w-full mb-1"
            placeholder="Description (required)"
            :required="Type!==typeConsants.SEGMENT? true : false"
            name="description"
            v-model="description"
            @input="onEdit"
          />
           <section v-if="Type !== typeConsants.SEGMENT">
          <div
            v-if="userInfo && userInfo.user.role === 'SUPERADMIN'"
            class="form-control py-3 w-full"
          >
            <div class="text-xl inline-block">Course Type:</div>

            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="mail"
                v-model="Type"
                @input="onEdit"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Mail</span>
            </label>

            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="twitter"
                v-model="Type"
                @input="onEdit"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Twitter</span>
            </label>
          </div>
          <div
            v-if="userInfo && userInfo.user.role === 'SUPERADMIN'"
            class="form-control"
          >
            <div class="text-xl inline-block">Deliver course on:</div>
            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="TWEET"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via Tweets</span>
            </label>

            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="DM"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via DM</span>
            </label>

            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="SITE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Twitter Engagement</span
              >
            </label>

            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="SITE-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Twitter Notification</span
              >
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Engagement</span
              >
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Notification</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="scheduled"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Scheduled</span>
              <input
                v-if="scheduled"
                type="datetime-local"
                placeholder="Date-Time"
                class="input input-bordered ml-5"
                required
                name="publishDateTime"
                v-model="publishDateTime"
                @input="onEdit"
              />
            </label>
          </div>
          <div
            v-if="scheduled && isNaN(new Date(publishDateTime).getTime())"
            class="text-red-500"
          >
            Please enter valid date time
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="linear"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Sequential</span>
            </label>
          </div>
          <div
            class="form-control"
          >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Frequency"
              />
              <span class="label-text text-lg ml-3">Frequency</span>
              <select
                v-model="frequency"
                v-if="Frequency"
                class="select select-bordered ml-5"
                @input="onEdit"
                required
              >
                <option disabled="disabled" value="">Choose frequency</option>
                <option value="DAILY">Daily</option>
                <option value="WEEKLY">Weekly</option>
              </select>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="Limitstudent"
                class="checkbox checkbox-primary"
                v-model="Limitstudent"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Limit Students</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Limitstudent"
            placeholder="Max. Students (required)"
            class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
            required
            name="maxStudents"
            min="1"
            oninput="validity.valid||(value='');"
            v-model="maxStudents"
            @input="onEdit"
          />
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Threadseries"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Create a thread series</span
              >
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="sharingtips"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Require Registration for sharing tips</span
              >
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="AllowsubmissionviaDM"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Allow assignment submission via DM
              </span>
              <span class="label-text text-md ml-3 mt-1"
                >( warn: conversations might be flagged as assignment
                submissions )</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="Charge"
                class="checkbox checkbox-primary"
                v-model="Charge"
                @input="
                  onEdit();
                  price = '';
                "
              />
              <span class="label-text text-lg ml-3">Charge for the course</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Charge && userInfo && userInfo.user.role === 'SUPERADMIN'"
            placeholder="Price (required)"
            class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
            required
            min="1"
            oninput="validity.valid||(value='');"
            name="price"
            v-model="price"
            @input="onEdit"
          />
          <div
            class="form-control w-95/100 ml-5/100"
            v-if="Charge && userInfo && userInfo.user.role === 'SUPERADMIN'"
          >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="PPP"
                class="checkbox checkbox-primary"
                v-model="PPP"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Use Purchasing Power Parity</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Enablehashtag"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Enable hashtag submission (premium)</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showBackground"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Background ( does not work for all settings )</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showCheck"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Check ( does not work for all settings )</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showFeedback"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Feedback ( does not work for all settings )</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showParticipate"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Participate ( does not work for all settings )</span
              >
            </label>
          </div>
          <div class="form-control" v-if="userInfo && userInfo.user.role === 'SUPERADMIN'">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showTakeaway"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Takeaway ( does not work for all settings )</span
              >
            </label>
          </div>
          <div class="flex">
            <div class="flex-grow">
              <input
                disabled
                type="text"
                placeholder="Image"
                class="input input-bordered w-full mb-2"
                name="img"
                v-model="img"
                @input="onEdit"
              />
            </div>
            <div class="flex-none ml-3">
              <input
                ref="selectedFile"
                class="w-full mt-3 text-indigo-700 outline-none bg-gray-100"
                type="file"
                name="selectedFile"
                style="display: none"
                accept="image/jpeg, image/png"
                @change="onImageUpload"
                @input="onEdit"
              />
              <button
                type="button"
                class="btn btn-outline"
                @click="$refs.selectedFile.click()"
              >
                Select...
              </button>
            </div>
          </div>
          <img width="500" class="pl-2" :src="imagePreview" alt="" />
           </section>
          <!--
          <div class="mt-3">
            <button type="submit" class="btn btn-primary ml-3">Save</button>
          </div>
          -->
        </div>
        <div class="my-10 max-w-lg mx-auto lg:max-w-3xl" v-if="userInfo && userInfo.user.role !== 'USER' && Type === typeConsants.SEGMENT">
            <!-- <div class="flex justify-between w-full items-center">
              <label
                class="cursor-pointer label mt-2 justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="fromQuery"
                />
                <span class="label-text text-lg ml-3">From Query</span>
              </label>
              <div class="flex items-center font-semibold">
                Members : {{ previewStudentList.length }}
              </div>
            </div> -->
            <div class="flex items-center justify-between" v-if="userInfo.user.role !== 'USER'">
              <label
                class="cursor-pointer label mt-2 justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="isDynamicSegment"
                />
                <span class="label-text text-lg ml-3">Make List Dynamic</span>
              </label>
              <div class="flex mt-2 font-semibold mb-0">
               Members : {{ previewStudentList ? previewStudentList.length : 0 }}
              </div>
            </div>

            <section v-if="isDynamicSegment" class="mt-0 w-full">
              <div
                class="w-full"
                v-for="(filterDetails, mainIndex) in filterList"
                :key="mainIndex"
              >
                <!-- filter group -->
                <section
                  class="w-full border border-gray-500 p-2 rounded-md mt-4"
                >
                  <!-- filter filter -->
                  <div class="w-full">
                    <!-- filter header start -->
                    <div class="label-text text-lg ml-3 flex justify-between">
                      <div>
                        Matching
                        <select
                          class="select select-bordered text-base mx-1"
                          v-model="filterDetails.matching"
                          @change="handleChangeMatching($event, mainIndex)"
                        >
                          <option disabled="disabled" value="">Select</option>
                          <option
                            v-for="(data, index) in Object.values(
                              filterConstantInside,
                            )"
                            :key="index"
                            :value="data"
                          >
                            {{ data }}
                          </option>
                        </select>
                        of the following
                      </div>
                      <div @click="handleRemoveGroup(mainIndex)">
                        <closeIcon />
                      </div>
                    </div>
                    <!-- filter header end -->
                    <div
                      v-for="(subFilter, subIndex) in filterDetails.filter"
                      :key="subIndex"
                    >
                      <div class="w-full mb-0">
                        <!-- filter matching start  -->
                        <p v-if="subIndex !== 0" class="text-center mb-0">
                          {{
                            filterDetails.matching === filterConstantInside.ALL
                              ? 'and'
                              : 'or'
                          }}
                        </p>
                        <!-- filter matching end  -->
                        <section
                          :class="[
                            'flex items-center w-full flex-wrap',
                            subIndex ? 'mt-2' : 'mt-5',
                          ]"
                        >
                          <section
                            v-if="isDynamicSegment"
                            class="flex items-center flex-wrap"
                          >
                            <!-- // options start  -->
                            <select
                              class="select select-bordered flex-1 mr-2 min-w-max"
                              required
                              v-model="subFilter.filterType"
                              @change="
                                handleChangeFiltertype(
                                  $event,
                                  subIndex,
                                  mainIndex,
                                )
                              "
                            >
                              <option disabled="disabled" value="">
                                Select...
                              </option>
                              <option :value="enrollFilterType.ENGAGED_IN">
                                Engaged
                              </option>
                              <option :value="enrollFilterType.COMMENTED_IN">
                                Commented
                              </option>
                              <option :value="enrollFilterType.IN_SEGMENT">
                                In segment
                              </option>
                              <option
                                :value="enrollFilterType.YOU_MESSAGED_THEM"
                              >
                                You messaged them
                              </option>
                              <option
                                :value="enrollFilterType.THEY_MESSAGED_YOU"
                              >
                                They messaged you
                              </option>
                              <option
                                :value="enrollFilterType.HAS_FOLLOWER_COUNT"
                              >
                                Has follower count
                              </option>
                              <option
                                :value="enrollFilterType.CAN_SEND_DM_QUERY"
                              >
                                Can send DM
                              </option>
                              <option :value="enrollFilterType.TWITTER_LIST">
                                Twitter List
                              </option>
                            </select>
                            <!-- // options end  -->
                            <!-- twiter list input  -->
                            <div  v-if="
                                (isDynamicSegment &&
                                  subFilter.filterType ===
                                    enrollFilterType.TWITTER_LIST)
                              ">
                              <input
                                type="text"
                                style="max-width: 220px"
                                placeholder="Twitter list Id"
                                class="input input-bordered h-8"
                                required
                                name="twitterListId"
                                 v-model="subFilter.twitterListId"
                                @change="
                                  handleChangeTwitterListId($event, subIndex, mainIndex)
                                "
                              />
                            </div>
                            <!-- twiter list input  -->
                            <!-- engaged, commented, and messaged type start  -->
                            <!-- Times start -->
                            <div
                              class="ml-2 flex items-center times_div"
                              v-if="
                                (isDynamicSegment &&
                                  subFilter.filterType ===
                                    enrollFilterType.ENGAGED_IN) ||
                                subFilter.filterType ===
                                  enrollFilterType.COMMENTED_IN ||
                                subFilter.filterType ===
                                  enrollFilterType.YOU_MESSAGED_THEM ||
                                subFilter.filterType ===
                                  enrollFilterType.THEY_MESSAGED_YOU
                              "
                            >
                              <input
                                type="number"
                                style="max-width: 80px"
                                placeholder="Engaged"
                                class="input input-bordered h-8"
                                required
                                name="engagedTimes"
                                v-model="subFilter.times"
                                @change="
                                  handleChangeTimes($event, subIndex, mainIndex)
                                "
                              />
                              <h5
                                class="mb-0 ml-2 text-sm font-semibold whitespace-no-wrap"
                              >
                                <!-- {{ subFilter.times == 1 ? 'Time in' : ' Times in' }}: -->
                                Time(s) in
                              </h5>
                            </div>
                            <!-- Times end -->
                            <!-- Duration -->
                            <div
                              class="mt-5 sm:mt-0 sm:ml-5"
                              style="max-width: 200px"
                            >
                              <select
                                class="select select-bordered flex-1 w-full"
                                required
                                v-model="subFilter.filterDuration"
                                v-if="
                                  (isDynamicSegment &&
                                    subFilter.filterType ===
                                      enrollFilterType.ENGAGED_IN) ||
                                  subFilter.filterType ===
                                    enrollFilterType.COMMENTED_IN ||
                                  subFilter.filterType ===
                                    enrollFilterType.YOU_MESSAGED_THEM ||
                                  subFilter.filterType ===
                                    enrollFilterType.THEY_MESSAGED_YOU
                                "
                                @change="
                                  handleChangeFilterDuration(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              >
                                <option disabled="disabled" value="">
                                  Select...
                                </option>
                                <option value="1">Last Day</option>
                                <option value="7">Last week</option>
                                <option value="14">2 weeks</option>
                                <option value="30">Last month</option>
                                <option value="90">3 Month</option>
                              </select>
                            </div>
                            <!-- engaged, commented, and messaged type end  -->
                            <!-- has followers type start  -->
                            <!-- option for operators start -->
                            <div
                              class="mt-5 sm:mt-0 sm:ml-5 lg:ml-0"
                              style="max-width: 200px"
                            >
                              <select
                                class="select select-bordered flex-1 w-full"
                                required
                                v-model="subFilter.filterOperator"
                                v-if="
                                  isDynamicSegment &&
                                  subFilter.filterType ===
                                    enrollFilterType.HAS_FOLLOWER_COUNT
                                "
                                @change="
                                  handleChangeFilterOprator(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              >
                                <option disabled="disabled" value="">
                                  Select...
                                </option>
                                <option :value="operator.LESS_THAN">
                                  Less than
                                </option>
                                <option :value="operator.EQUALT_TO">
                                  Equal to
                                </option>
                                <option :value="operator.MORE_THAN">
                                  More than
                                </option>
                              </select>
                            </div>
                            <!-- Times start -->
                            <div
                              class="ml-2 flex items-center times_div"
                              v-if="
                                isDynamicSegment &&
                                subFilter.filterType ===
                                  enrollFilterType.HAS_FOLLOWER_COUNT
                              "
                            >
                              <input
                                type="number"
                                style="max-width: 100px"
                                placeholder="Engaged"
                                class="input input-bordered h-8"
                                required
                                name="engagedTimes"
                                v-model="subFilter.followers"
                                @change="
                                  handleChangeFollowers(
                                    $event,
                                    subIndex,
                                    mainIndex,
                                  )
                                "
                              />
                            </div>
                            <!-- Times end -->
                            <!-- option for operators start -->
                          </section>

                          <!-- segmeny list  -->
                          <select
                            v-if="
                              isDynamicSegment &&
                              subFilter.filterType ===
                                enrollFilterType.IN_SEGMENT &&
                              subFilter.filterType !== ''
                            "
                            class="select select-bordered flex-1 mr-10 mt-5 sm:mt-0"
                            style="max-width: 200px"
                            required
                            @change="
                              handleChangeSegment($event, subIndex, mainIndex)
                            "
                            v-model="filterDetails.filter[subIndex].segment"
                          >
                            <option disabled="disabled" value="">
                              Select Segment
                            </option>
                            <option
                              v-for="(item, index) in segmentList"
                              :value="item._id"
                              :key="index"
                            >
                              {{ item.title.slice(0, 30)
                              }}{{ item.title.length > 30 ? '...' : '' }}
                            </option>
                          </select>
                          <div
                            class="ml-auto"
                            @click="handleRemoveFilter(subIndex, mainIndex)"
                          >
                            <closeIcon />
                          </div>
                        </section>
                      </div>
                    </div>

                    <button
                      :class="['mt-5 btn btn-primary w-full']"
                      @click="handleAddFilter(mainIndex)"
                    >
                      Add Filter
                    </button>
                  </div>
                </section>
              </div>
              <button
                class="btn btn-outline w-full mt-5"
                @click="handleAddGroup"
              >
                Add Filter Group
              </button>
            </section>
        </div>
      </form>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Do you really want to leave? You have unsaved changes !
              </div>
            </div>
            <br />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="nextpage">leave</button>
              <button class="btn btn-outline ml-3" @click="feedPopup = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import courseAPI from '@/services/course';
import userInfo from '@/services/userInfo';
import store from '@/store';
import courseType from '../../../utils/Constants/courseType.constants';
import enrollFilterType from '@/utils/Constants/enrollFilterType.contstants';
import utils from '@/services/utils';
import closeIcon from '@/components/icons/closeIcon.vue';

const filterConstant = {
  ANY: 'Any',
  ALL: 'All',
  NONE: 'None',
};

export default {
  name: 'topics',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: null,
      courseId: null,
      title: '',
      description: '',
      price: '',
      maxStudents: '',
      linear: false,
      Type: 'twitter',
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      frequency: '',
      Frequency: false,
      publish: true,
      image: null,
      Deliver: 'TWEET',
      imagePreview: '',
      img: '',
      courseData: null,
      feedPopup: false,
      autosave: null,
      sharingtips: false,
      Enablehashtag: false,
      Threadseries: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      nextpage: null,
      ischange: false,
      Limitstudent: false,
      typeConsants: courseType,
      filterList: [
        {
          matching: filterConstant.ANY,
          filter: [],
        },
      ],
      filterConstantInside: filterConstant,
      enrollFilterType,
      fromQuery: false,
      isDynamicSegment: false,
      previewStudentList: [],
      userId: '',
    };
  },
  components: { closeIcon },
  computed: {
    user() {
      return store.state?.user;
    },
    segmentList() {
      return this.$store.state.courses.courses;
    },
  },
  async mounted() {
    window.addEventListener('beforeunload', (e) => {
      if (this.ischange) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    this.courseId = this.$route.params.courseId;
    this.userId = this.user?.uid;
    if (this.$route.query.userId) {
      this.userId = this.$route.query.userId;
    }
    this.userInfo = await userInfo.getUserInfo(this.userId);
    this.$store.dispatch('fetchCoursesList', this.userInfo?.user?.userId);
    store.commit('toggleLoading', true);
    this.courseData = await courseAPI.getCourse(this.courseId);
    store.commit('toggleLoading', false);
    this.title = this.courseData.course.title;
    this.description = this.courseData.course.description;
    this.price = this.courseData.course.price;
    this.PPP = this.courseData.course.purchaseParityEnabled;
    this.Charge = this.courseData.course.price !== 0;
    this.maxStudents = this.courseData.course.maxStudents;
    this.linear = this.courseData.course.linear;
    this.scheduled = this.courseData.course.scheduled;
    this.publish = this.courseData.course.publish;
    this.Limitstudent = this.courseData.course.setStudentLimit;
    this.Type = this.courseData.course.type;
    this.sharingtips = this.courseData.course.sharingtips;
    this.Enablehashtag = this.courseData.course.Enablehashtag;
    this.Threadseries = this.courseData.course.Threadseries;
    this.showBackground = this.courseData.course.showBackground;
    this.showCheck = this.courseData.course.showCheck;
    this.showFeedback = this.courseData.course.showFeedback;
    this.showParticipate = this.courseData.course.showParticipate;
    this.showTakeaway = this.courseData.course.showTakeaway;
    this.AllowsubmissionviaDM = this.courseData.course.AllowsubmissionviaDM;
    this.Deliver = this.courseData.course.medium;
    const publishDateTimeISO = new Date(this.courseData.course.publishDateTime);
    publishDateTimeISO.setMinutes(
      publishDateTimeISO.getMinutes() - publishDateTimeISO.getTimezoneOffset(),
    );
    this.publishDateTime = publishDateTimeISO.toISOString().slice(0, 16);
    this.frequency = this.courseData.course.frequency;
    this.Frequency = this.courseData.course.Frequency;
    this.imagePreview = this.courseData.course.image;
    const imgParts = this.courseData?.course?.image?.split('/');
    this.filterList = this.courseData?.course?.filterList || [];
    this.fromQuery = this.courseData?.course?.fromQuery;
    this.isDynamicSegment = this.courseData.course?.isDynamicSegment;
    this.img = imgParts?.at(-1);
    this.createfromQuery();
  },
  beforeDestroy() {
    clearTimeout(this.autosave);
  },
  beforeRouteLeave(to, from, next) {
    if (this.ischange) {
      this.feedPopup = true;
      this.nextpage = next;
    } else {
      next();
    }
  },

  methods: {
    onImageUpload(e) {
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        const data = URL.createObjectURL(this.image);
        this.imagePreview = data;
        console.log(data, 'data');
      }
    },
    onEdit() {
      console.log('edit');
      this.ischange = true;
      clearTimeout(this.autosave);
      this.autosave = setTimeout(() => this.autosaveCourse(), 10000);
    },
    async updateCourse() {
      store.commit('toggleLoading', true);
      let secureUrl = '';
      if (this.image !== null) {
        const cloudName = 'implicit';
        const formData = new FormData();
        formData.append('upload_preset', 'courses');
        formData.append('file', this.image);
        if (this.image) {
          const res = await axios
            .post(
              `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
              formData,
              {
                transformRequest: (data, headers) => {
                  // eslint-disable-next-line no-param-reassign
                  delete headers.common.Authorization;
                  return data;
                },
              },
            )
            .catch((e) => console.log(e));
          if (res) secureUrl = res.data.secure_url;
        }
      }
      const publishDateTime = new Date(this.publishDateTime);
      let payload = {
        title: this.title,
        description: this.description,
        price: this.price === '' ? 0 : this.price,
        maxStudents: this.maxStudents,
        linear: this.linear,
        scheduled: this.scheduled,
        publishDateTime: this.scheduled
          ? publishDateTime.getTime()
          : new Date().getTime(),
        frequency: this.Frequency ? this.frequency : '',
        Frequency: this.Frequency,
        publish: this.publish,
        currency: 'USD',
        purchaseParityEnabled: this.PPP,
        medium: this.Deliver,
        setStudentLimit: this.Limitstudent,
        sharingtips: this.sharingtips,
        Enablehashtag: this.Enablehashtag,
        Threadseries: this.Threadseries,
        showBackground: this.showBackground,
        showCheck: this.showCheck,
        showFeedback: this.showFeedback,
        showParticipate: this.showParticipate,
        showTakeaway: this.showTakeaway,
        AllowsubmissionviaDM: this.AllowsubmissionviaDM,
        type: this.Type,
        filterList: this.filterList,
        fromQuery: this.isDynamicSegment,
        isDynamicSegment: this.isDynamicSegment,
      };
      if (secureUrl !== '') {
        payload = { ...payload, image: secureUrl };
      }
      console.log(this.userInfo, ';this.userInfo');
      courseAPI
        .updateCourse(this.courseId, payload, this.userInfo?.user?.userId)
        .then(() => {
          this.ischange = false;
          store.commit('toggleLoading', false);
          if (this.Type === this.typeConsants.SEGMENT) {
            this.$router.push('/admin/audience');
          } else {
            this.$router.push('/admin/products/');
          }
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    async autosaveCourse() {
      // let secureUrl = '';
      // if (this.image !== null) {
      //   const cloudName = 'implicit';
      //   const formData = new FormData();
      //   formData.append('upload_preset', 'courses');
      //   formData.append('file', this.image);
      //   if (this.image) {
      //     const res = await axios
      //       .post(
      //         `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
      //         formData,
      //         {
      //           transformRequest: (data, headers) => {
      //             // eslint-disable-next-line no-param-reassign
      //             delete headers.common.Authorization;
      //             return data;
      //           },
      //         },
      //       )
      //       .catch((e) => console.log(e));
      //     if (res) secureUrl = res.data.secure_url;
      //   }
      // }
      // const publishDateTime = new Date(this.publishDateTime);
      // let payload = {
      //   title: this.title,
      //   description: this.description,
      //   price: this.price === '' ? 0 : this.price,
      //   maxStudents: this.maxStudents,
      //   linear: this.linear,
      //   scheduled: this.scheduled,
      //   publishDateTime: this.scheduled
      //     ? publishDateTime.getTime()
      //     : new Date().getTime(),
      //   frequency: this.scheduled ? this.frequency : '',
      //   publish: this.publish,
      //   currency: 'USD',
      //   purchaseParityEnabled: this.PPP,
      //   medium: this.Deliver,
      //   setStudentLimit: this.Limitstudent,
      //   sharingtips: this.sharingtips,
      //   Enablehashtag: this.Enablehashtag,
      //   showBackground: this.showBackground,
      //   showCheck: this.showCheck,
      //   showFeedback: this.showFeedback,
      //   showParticipate: this.showParticipate,
      //   showTakeaway: this.showTakeaway,
      //   AllowsubmissionviaDM: this.AllowsubmissionviaDM,
      //   type: this.Type,
      // };
      // if (secureUrl !== '') {
      //   payload = { ...payload, image: secureUrl };
      // }
      // courseAPI
      //   .updateCourse(this.courseId, payload)
      //   .then(() => {
      //     console.log('updated');
      //     this.ischange = false;
      //   })
      //   .catch((error) => {
      //     store.commit('toggleLoading', false);
      //     if (error.response.status === 401) {
      //       utils.setStatusMsg(
      //         this,
      //         'Unauthorized access, redirected to implicit',
      //       );
      //       this.$router.push({ path: '/' });
      //     }
      //     console.log({ error });
      //   });
    },
    handleAddGroup() {
      if (this.filterList) {
        this.filterList.push({
          matching: filterConstant.ANY,
          filter: [
            {
              filterType: '',
              filterDuration: '',
              times: 1,
              segment: '',
              filterOperator: '',
              followers: 1000,
              canSendDMQuery: false,
              twitterListId: '',
            },
          ],
        });
      } else {
        this.filterList = [{
          matching: filterConstant.ANY,
          filter: [
            {
              filterType: '',
              filterDuration: '',
              times: 1,
              segment: '',
              filterOperator: '',
              followers: 1000,
              canSendDMQuery: false,
              twitterListId: '',
            },
          ],
        }];
      }
    },
    handleRemoveGroup(index) {
      this.createfromQuery();
      this.filterList.splice(index, 1);
    },
    handleAddFilter(index) {
      // console.log(this.filterList, index);
      this.filterList[index].filter.push({
        filterType: '',
        filterDuration: '',
        times: 1,
        segment: '',
        filterOperator: '',
        followers: 1000,
        canSendDMQuery: false,
        twitterListId: 0,
      });
    },
    handleRemoveFilter(index, mainIndex) {
      this.filterList[mainIndex].filter.splice(index, 1);
      this.createfromQuery();
    },
    handleChangeMatching(e, index) {
      this.filterList[index].matching = e.target.value;
      this.createfromQuery();
    },
    handleChangeSegment(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].segment = e.target.value;
      this.createfromQuery();
    },
    handleChangeFiltertype(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterType = e.target.value;
      if (enrollFilterType.YOU_MESSAGED_THEM === e.target.value) {
        this.filterList[mainIndex].filter[subIndex].filterDuration = '7';
      } else {
        this.filterList[mainIndex].filter[subIndex].filterDuration = '';
      }
      console.log(
        'working and calling',
        this.filterList[mainIndex]?.filter[subIndex],
      );
      this.filterList[mainIndex].filter[subIndex].canSendDMQuery =
        enrollFilterType.CAN_SEND_DM_QUERY === e.target.value;
      this.createfromQuery();
    },
    handleChangeFilterDuration(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterDuration =
        e.target.value;
      this.createfromQuery();
    },
    handleChangeFilterOprator(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].filterOperator =
        e.target.value;
      this.createfromQuery();
    },
    handleChangeTimes(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].times = e.target.value;
      this.createfromQuery();
    },
    handleChangeFollowers(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].followers = e.target.value;
      this.createfromQuery();
    },
    handleChangeTwitterListId(e, subIndex, mainIndex) {
      this.filterList[mainIndex].filter[subIndex].twitterListId =
        e.target.value;
      this.createfromQuery();
    },
    handleClosePreviewPopup() {
      this.openPreviewPop = !this.openPreviewPop;
      this.createfromQuery();
    },
    async createfromQuery() {
      try {
        this.previewStudentList = await this.$store.dispatch('createCourse',
          {
            filterList: this.filterList,
            userId: this.userInfo?.user?.userId,
            isConfirm: false,
            fromQuery: true,
          });
        console.log(this.previewStudentList, 'memberInfo');
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'Something went wrong');
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
